export const USER_ROLES = {
  SUPER_ADMIN: 'super_admin',
  ADMIN: 'admin',
  TEAM_LEAD: 'team_lead',
  REFERRAL_PARTNER: 'referral_partner',
  DOCUMENTS_MANAGER: 'documentation_manager',
  ACCOUNTS_MANAGER: 'accounts_manager',
  SEO_MANAGER: 'seo_manager'
};

export const ENQUIRY_STATUS = {
  NEW: 'new',
  IN_PROGRESS: 'in_progress',
  COMPLETED: 'completed',
  CANCELLED: 'cancelled'
};

export const API_ENDPOINTS = {
  DASHBOARD: '/dashboard/stats',
  REFERRAL_PARTNERS: '/referral-partners',
  TEAM_LEADS: '/team-leads',
  ADMISSIONS: '/admissions',
  ENQUIRIES: '/enquiries'
};